import React, { useState, useEffect } from 'react'
import { SafeAreaView, ActivityIndicator, RefreshControl } from 'react-native'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigation } from '@react-navigation/native'
import tw from 'tailwind-rn'
import ActionCreators from '../../store/actions'

// import * as v from '../../config/variables'
import { HGView, HGHeading, HGFlatList, HGText } from '../../components/HGUI'
import NewsListItem from './NewsListItem'
import { NewsItemType } from '../../config/types'

const NewsOverviewScreen = () => {
  const [loading, setLoading] = useState(false)
  const [noContent, setNoContent] = useState(false)
  const [refreshing] = useState(false)
  const dispatch = useDispatch()
  const navigation = useNavigation()
  const { list: news } = useSelector((state) => state.news)

  const loadNewsList = async () => {
    setLoading(true)

    try {
      await dispatch(ActionCreators.loadNewsList())
      setNoContent(false)
    } catch (reason) {
      setNoContent(true)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    loadNewsList()
  }, [])

  return (
    <SafeAreaView style={{ flex: 1 }}>
      <HGFlatList
        refreshControl={
          <RefreshControl
            refreshing={refreshing}
            onRefresh={() => loadNewsList()}
          />
        }
        contentContainerStyle={tw('px-3')}
        data={news}
        ListHeaderComponent={
          <HGView>
            <HGHeading>Neues</HGHeading>

            {loading && !refreshing && !news.length && (
              <ActivityIndicator style={tw('my-2')} />
            )}

            {news.length > 0 && noContent && (
              <HGText>Es gibt noch keine Nachrichten.</HGText>
            )}
          </HGView>
        }
        renderItem={({ item }) => {
          return (
            <HGView>
              <NewsListItem
                newsItem={item}
                key={item.id.toString()}
                onNewsItemPress={() => {
                  navigation.navigate('NewsDetail', {
                    newsId: item.id,
                    // title: item.title,
                  })
                }}
              />
            </HGView>
          )
        }}
        keyExtractor={({ id }) => id.toString()}
      />
    </SafeAreaView>
  )
}

export default NewsOverviewScreen
